// Format any date-ish value (ISO string, YYYY-MM-DD, or Date) as dd/mm/yyyy.
// Returns "—" for falsy or unparseable values.
export function formatDMY(value) {
  if (!value) return "—";
  const s = String(value);
  // Fast path for YYYY-MM-DD or ISO leading with YYYY-MM-DD
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(s);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

// Today's calendar date in Sydney as YYYY-MM-DD (never UTC — UTC is "yesterday" until ~10am AEST).
export function sydneyToday(offsetDays = 0) {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Australia/Sydney", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  if (!offsetDays) return parts;
  const d = new Date(`${parts}T00:00:00`); d.setDate(d.getDate() + offsetDays);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// Build the next `count` days as {iso, label, day, dow, monthShort} for scrollers.
export function upcomingDays(count = 42, startOffset = 0) {
  const out = [];
  const base = new Date(`${sydneyToday()}T00:00:00`);
  for (let i = startOffset; i < startOffset + count; i++) {
    const d = new Date(base);
    d.setDate(base.getDate() + i);
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    out.push({
      iso,
      day: d.getDate(),
      dow: d.toLocaleDateString("en-AU", { weekday: "short" }).toUpperCase(),
      monthShort: d.toLocaleDateString("en-AU", { month: "short" }).toUpperCase(),
      isToday: i === 0,
      isWeekend: d.getDay() === 0 || d.getDay() === 6,
    });
  }
  return out;
}


const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// Human label for a job's hire days, mirrors backend work_dates_label: "Mon 3, Tue 4 & Thu 6 Nov (3 days)".
export function workDatesLabel(t = {}) {
  const days = [...new Set((t.work_dates || []).map((x) => String(x).slice(0, 10)))].sort();
  if (t.flexible && t.end_date) return `Any ${t.duration_days || 1} day${(t.duration_days || 1) !== 1 ? "s" : ""} between ${formatDMY(t.start_date)} and ${formatDMY(t.end_date)}`;
  if (!days.length) return t.start_date ? formatDMY(t.start_date) : "—";
  const ds = days.map((d) => new Date(`${d}T00:00:00`));
  const one = (d, m = true) => `${DOW[d.getDay()]} ${d.getDate()}${m ? ` ${MON[d.getMonth()]}` : ""}`;
  if (ds.length === 1) return `${one(ds[0])} (${formatDMY(days[0])})`;
  const sameMonth = ds[0].getMonth() === ds[ds.length - 1].getMonth();
  const consecutive = ds.every((d, i) => i === 0 || (d - ds[i - 1]) / 86400000 === 1);
  if (consecutive) return `${one(ds[0], !sameMonth)} – ${one(ds[ds.length - 1])} (${ds.length} days)`;
  const parts = ds.map((d, i) => one(d, !sameMonth || i === ds.length - 1));
  return `${parts.slice(0, -1).join(", ")} & ${parts[parts.length - 1]} (${ds.length} days)`;
}
